export default __webpack_public_path__ + "static/media/Manrope-Medium.4a88d55f.ttf";